import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { ADMIN_AFFILIATES_APPROVED_ROUTE_NAME } from '@modules/affiliates-approved/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  ADMIN_AFFILIATE_PROFILE_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATE_PROFILE,
} from './constants';
import { AffiliatesApprovedProfileContactsModule } from './submodules/contacts/ProfileContactsModule';
import { AFFILIATE_PROFILE_GENERAL_ROUTE_NAME } from './submodules/general/constants';
import { AffiliatesApprovedProfileGeneralModule } from './submodules/general/ProfileGeneralModule';
import { AffiliatesApprovedProfileSubaffiliateModule } from './submodules/subaffiliate/ProfileSubaffiliateModule';
import { getTranslationKeys } from './translations';

export class AffiliatesApprovedProfileModule extends AppModule {
  protected submodules: AppModule[] = [
    new AffiliatesApprovedProfileGeneralModule(),
    new AffiliatesApprovedProfileContactsModule(),
    new AffiliatesApprovedProfileSubaffiliateModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_AFFILIATES_APPROVED_ROUTE_NAME, {
      name: ADMIN_AFFILIATE_PROFILE_ROUTE_NAME,
      path: 'profile/:id',
      component: () => import('./pages/AffiliateProfilePage/AffiliateProfilePage.vue'),
      redirect: { name: AFFILIATE_PROFILE_GENERAL_ROUTE_NAME },
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATE_PROFILE, getTranslationKeys);
  }
}
